<template>
  <div style="vertical-align: middle; line-height: 32px; font-size: 32px; aspect-ratio: 2;">{{flag}}</div>
</template>

<script>
function getFlag(countryCode) {
  const pts = countryCode.toUpperCase().split('').map(x => 127397 + x.charCodeAt());
  return String.fromCodePoint(...pts);
}

export default {
  name: 'country-flag',
  props: [ 'country' ],
  computed: {
    flag() {
      const pts = this.country.toUpperCase().split('').map(x => 127397 + x.charCodeAt());
      return String.fromCodePoint(...pts);
    }
  }
}
</script>
